import { InputForm } from "../types"

export const MESSAGE_HISTORY_SENT_COLUMNS = [
    {
        field: 'dateSent',
        headerName: 'Date Sent',
        width: '20%',
    },
    {
        field: 'type',
        headerName: 'Type',
        width: '20%',
    },
    {
        field: 'title',
        headerName: 'Title',
        width: '25%',
    },
    {
        field: 'recipientCount',
        headerName: 'Recipients',
        width: '15%',
    },
    {
        field: 'channels',
        headerName: 'Delivery Method',
        width: '20%',
    },
]

export const MESSAGE_HISTORY_UNSENT_COLUMNS = [
    {
        field: 'scheduledDate',
        headerName: 'Scheduled Date',
        width: '20%',
    },
    {
        field: 'type',
        headerName: 'Type',
        width: '20%',
    },
    {
        field: 'title',
        headerName: 'Title',
        width: '25%',
    },
    {
        field: 'recipientCount',
        headerName: 'Recipients',
        width: '15%',
    },
    {
        field: 'channels',
        headerName: 'Delivery Method',
        width: '20%',
    },
]

export const MESSAGE_HISTORY_FILTER_INPUTS: InputForm[] = [
    {
        label: 'Title',
        id: 'title',
        type: 'text',
        required: false,
        placeholder: 'Filter by message title',
        grid: {
            xs: 6,
            sm: 6,
            md: 6,
        },
    },
    {
        label: 'Body',
        id: 'body',
        type: 'text',
        required: false,
        placeholder: 'Filter by message body',
        grid: {
            xs: 6,
            sm: 6,
            md: 6,
        },
    },
]